"use client";
import {LiveFilter} from "@/components/@filter/live-filter";
import {NeoModal} from "@/components/@modal/neo.modal";
import {NeoButton, NeoSelect, NeoTextBox} from "@/components/forms";
import {NeoChips, NeoTabs, SearchIcon} from "@/components/shared";

import {useLiveContext} from "@/context/live/live.context";
import {useNeoContext} from "@/context/neo/neo.context";
import {LiveConfig} from "@/data";
import {
  CustomerType,
  GPSTracker,
  PageType,
  PaginationAction,
  PlayBackType,
  StatusType
} from "@/libs/enums/live";

import {
  Avatar,
  Button,
  Chip,
  Image,
  Popover,
  PopoverContent,
  PopoverTrigger,
  SelectItem,
  Spinner,
  Tab,
  Tabs,
  Tooltip
} from "@nextui-org/react";
import type {NextPage} from "next";
import {useEffect, useRef, useState} from "react";
import {LivePlayback} from "./live-playback";
import {MapView} from "./map-view";
import {TimelineView} from "./timeline-view";
import {TripView} from "./trip-view";
import {TripMapView} from "./tripmap-view";
import {VehicleView} from "./vehicle-view";
const liveConfig = LiveConfig as LivePageConfig;

export const Live: NextPage = function () {
  const leftContent = useRef<HTMLDivElement>(null);
  const rightContent = useRef<HTMLDivElement>(null);
  const [hideFeatures, setHideFeatures] = useState(true);
  const {filterContext, clients} = useNeoContext();
  const [leftContentHeight, setLeftContentHeight] = useState(0);
  const [rightContentHeight, setRightContentHeight] = useState(0);
  const {countDown, setGpsTracker, meta, vehicleRoutes} = useLiveContext();
  const [viewTitle, setViewTitle] = useState<string>("Maps");
  const [selectedPage, setSelectedPage] = useState<PageType>(PageType.LIVE);
  const reload = useRef(false);
  const [vehicleSelctedRoute, setVehicleSelctedRoute] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<StatusType>(
    StatusType.ALL
  );
  const [selectedView, setSelectedView] = useState<PlayBackType>(
    PlayBackType.MAPS
  );
  const [selectedDateRange, setSelectedDateRange] = useState<DateRange>({
    from: null,
    to: null
  });
  const [pagination, setPagination] = useState<Pagination>({
    currentPage: 1,
    totalPages: 10
  });
  const {filterValues, setFilterValues} = useLiveContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [remainderData, setRemainderData] = useState();
  const [actionType, setActionType] = useState<string>("");
  const [tripdata, setTripData] = useState<any>({});
  const [isPlayback, setIsPlayback] = useState(false);

  useEffect(() => {
    if (leftContent.current)
      setLeftContentHeight(leftContent?.current?.clientHeight);
    if (rightContent.current)
      setRightContentHeight(rightContent.current.clientHeight);
  }, [selectedPage]);

  useEffect(() => {
    setVehicleSelctedRoute("");
    if (selectedView == 2) {
      if (vehicleRoutes?.trips && vehicleRoutes?.trips.length > 0) {
        setVehicleSelctedRoute(vehicleRoutes?.trips[0].id);
      }
      setIsPlayback(false);
    } else if (selectedPage === PageType.LIVE && selectedView == 1) {
      setGpsTracker(GPSTracker.START);
    }
  }, [vehicleRoutes, selectedView]);

  const onDateChange = (event: any) => {
    setSelectedDateRange(event);
  };

  const handleSearch = (value: any) => {
    setFilterValues(prev => ({
      ...prev,
      searchText: value
    }));
  };

  const handleFilter = (ev: any) => {
    setFilterValues(prev => ({
      ...prev,
      driverId: ev?.driver,
      vehicleId: ev?.vehicle
    }));
  };
  useEffect(() => {
    if (clients.length > 0) {
      if (filterContext?.client?.customerType) {
        liveConfig.statusType = liveConfig.statusType.filter(type =>
          type.acceptCustomerType?.includes(filterContext.client.customerType)
        );
        //playBackType
        liveConfig.playBackType = liveConfig.playBackType.filter(type =>
          type.acceptCustomerType?.includes(filterContext.client.customerType)
        );
      }
      if (clients[0]["paymentReminder"]) {
        setModalOpen(true);
        setRemainderData(clients[0]["paymentReminder"]);
      }
    }
  }, [clients]);
  useEffect(() => {
    setFilterValues(prev => ({
      ...prev,
      currentPage: pagination.currentPage,
      totalPage: pagination.totalPages
    }));
  }, [pagination]);

  useEffect(() => {
    if (meta) {
      liveConfig.statusType.map(x => {
        switch (x.key) {
          case 0:
            return (x.count = meta.totalVehicles);
          case 1:
            return (x.count = meta.inProgressTrips);
          case 2:
            return (x.count = meta.completedTrips);
          default:
            return (x.count = meta.notInTrips);
        }
      });
    }
  }, [meta]);

  const openCalenManually = (datePickerRef: any) => {
    datePickerRef?.current?.openCalendar();
  };
  const handlePagination = (action: PaginationAction) => {
    if (
      action === PaginationAction.FORWARD &&
      pagination.currentPage < pagination.totalPages
    ) {
      setPagination(prev => ({...prev, currentPage: prev.currentPage + 1}));
    } else if (
      action === PaginationAction.BACKWARD &&
      pagination.currentPage > 1
    ) {
      setPagination(prev => ({...prev, currentPage: prev.currentPage - 1}));
    }
  };

  const handlePlayBackSwitch = (arg: any) => {
    const next =
      typeof arg === "boolean" ? arg : (arg?.target?.checked ?? false); // normalize event → boolean
    setIsPlayback(next);
  };

  const renderPageTabs = () => (
    <div className="flex w-[99%] gap-1 overflow-hidden rounded-xl border border-gray-200 bg-white p-0.5">
      <NeoButton
        size="sm"
        variant={selectedPage === PageType.LIVE ? "solid" : undefined}
        color="default"
        disabled={selectedPage === PageType.LIVE}
        className={
          selectedPage === PageType.LIVE
            ? "flex-1 cursor-pointer rounded-lg bg-black text-white shadow-none"
            : "flex-1 cursor-pointer rounded-lg bg-white shadow-none"
        }
        onClick={() => {
          setViewTitle("Live");
          setSelectedPage(PageType.LIVE);
          setSelectedStatus(StatusType.ALL);
          setGpsTracker(GPSTracker.START);
          setSelectedView(PlayBackType.MAPS);
          handlePlayBackSwitch(false);
        }}
      >
        Live
      </NeoButton>
      <NeoButton
        size="sm"
        variant={selectedPage === PageType.TRIP ? "solid" : undefined}
        color="default"
        disabled={selectedPage === PageType.TRIP}
        className={
          selectedPage === PageType.TRIP
            ? "flex-1 cursor-pointer rounded-lg bg-black text-white shadow-none"
            : "flex-1 cursor-pointer rounded-lg bg-white shadow-none"
        }
        onClick={() => {
          setViewTitle("Trips");
          setSelectedPage(PageType.TRIP);
          setGpsTracker(GPSTracker.STOP);
          setSelectedView(PlayBackType.TRIP);
          handlePlayBackSwitch(false);
        }}
      >
        Trips
      </NeoButton>
      <NeoButton
        size="sm"
        variant={selectedPage === PageType.PLAYBACK ? "solid" : undefined}
        color="default"
        disabled={selectedPage === PageType.PLAYBACK}
        className={
          selectedPage === PageType.PLAYBACK
            ? "flex-1 cursor-pointer rounded-lg bg-black text-white shadow-none"
            : "flex-1 cursor-pointer rounded-lg bg-white shadow-none"
        }
        onClick={() => {
          setViewTitle("History");
          setSelectedPage(PageType.PLAYBACK);
          setGpsTracker(GPSTracker.PLAYBACK);
          setSelectedView(PlayBackType.MAPS);
          handlePlayBackSwitch(false);
        }}
      >
        History
      </NeoButton>
    </div>
  );

  if (selectedPage === PageType.PLAYBACK) {
    return (
      <div className="h-[calc(100vh-63px)] w-full overflow-hidden bg-[#f6f8fc]">
        <div className="h-full overflow-hidden [&>main>div]:h-full [&>main]:h-full [&>main]:min-h-0">
          <LivePlayback
            pageTabs={hideFeatures ? renderPageTabs() : undefined}
          />
        </div>
        <NeoModal
          actionType={"paymentReminder"}
          onOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          hasActions={false}
          data={remainderData}
        ></NeoModal>
      </div>
    );
  }

  return (
    <div className="flex h-[calc(100vh-63px)] w-full overflow-hidden">
      <div className=" flex w-full flex-col md:flex-row">
        <div className="w-6/6 flex h-full flex-col border-l border-r border-gray-200 bg-white xl:w-3/12">
          <div ref={leftContent} className="sticky top-0 py-3">
            {hideFeatures && (
              <>
                {renderPageTabs()}
                {/*<div className="flex items-center justify-center">
                  <NeoButtonGroup
                    radius="full"
                    className="flex gap-1 overflow-hidden rounded-xl border border-gray-200 p-0.5 bg-white w-4/3"
                  >
                    <NeoButton
                      size="sm"
                      variant={selectedPage === PageType.LIVE ? "solid" : "light"}
                      color="default"
                      className={
                        selectedPage === PageType.LIVE
                          ? "bg-black text-white shadow-none w-1/2 rounded"
                          : "bg-transparent text-gray-900 hover:bg-gray-100 shadow-none w-1/2 rounded"
                      }
                      onClick={() => {
                        setViewTitle("Live");
                        setSelectedPage(PageType.LIVE);
                        setSelectedStatus(StatusType.ALL);
                        setGpsTracker(GPSTracker.STOP);
                      }}
                    >
                      Live
                    </NeoButton>
                    <NeoButton
                      size="sm"
                      radius="full"
                      variant={selectedPage === PageType.TRIP ? "solid" : "light"}
                      color="default"
                      className={
                        selectedPage === PageType.TRIP
                          ? "bg-black text-white shadow-none w-1/2"
                          : "bg-transparent text-gray-900 hover:bg-gray-100 shadow-none w-1/2"
                      }
                      onClick={() => {
                        setViewTitle("Trips");
                        setSelectedPage(PageType.TRIP);
                        setGpsTracker(null);
                        setSelectedView(PlayBackType.TRIP);
                      }}
                    >
                      Trips
                    </NeoButton>
                  </NeoButtonGroup>
                </div>
                <div className="flex items-center justify-center gap-2 p-1">
                  <div className="flex items-center gap-2">
                    <Button
                      onClick={() => handlePagination(PaginationAction.BACKWARD)}
                      isIconOnly
                      variant="light"
                      className="w-2 min-w-max"
                    >
                      <IoIosArrowBack />
                    </Button>
                    <Label
                      className="whitespace-nowrap text-xs"
                      value={`${pagination.currentPage} / ${pagination.totalPages}`}
                    />
                    <Button
                      onClick={() => handlePagination(PaginationAction.FORWARD)}
                      isIconOnly
                      variant="light"
                      className="w-2 min-w-max"
                    >
                      <IoIosArrowForward />
                    </Button>
                  </div> 
                </div>*/}
              </>
            )}
            {selectedPage === PageType.LIVE && (
              <>
                {!isPlayback && (
                  <div className="mt-2 flex w-[99%] items-center justify-center overflow-y-auto rounded-xl bg-gray-100 p-1">
                    <Tabs
                      aria-label="Options"
                      color="primary"
                      variant="underlined"
                      defaultSelectedKey={selectedStatus}
                      onSelectionChange={key => {
                        setSelectedStatus(key as StatusType);
                        setGpsTracker(GPSTracker.STOP);
                      }}
                      classNames={{
                        tabList: "gap-0 w-full items-center p-2 bg-gray-100",
                        cursor: "w-full bg-neo-green",
                        tab: " h-12 ", // px-1
                        tabContent: "group-data-[selected=true]:text-neo-green"
                        // tab: "bg-gray-200 h-14 data-[selected=true]:bg-white",
                        //tabList: "bg-gray-100 gap-0 p-0 rounded",
                        // cursor: "w-full bg-neo-green top-0"
                      }}
                    >
                      {liveConfig?.statusType?.map(item => (
                        <Tab
                          key={item?.key}
                          title={
                            <div className="flex flex-col items-center justify-center">
                              <span className="text-xs text-neo-black">
                                {(item?.status === "all" && "All") ||
                                  (item?.status === "in-progress" &&
                                    "On Trip") ||
                                  (item?.status === "completed" &&
                                    "Completed") ||
                                  (item?.status === "off-trip" &&
                                    "Not In Trip")}
                              </span>
                              <Chip
                                className="mb-2 mt-1"
                                size="sm"
                                color={
                                  (item?.status === "all" && "default") ||
                                  (item?.status === "in-progress" &&
                                    "primary") ||
                                  (item?.status === "completed" && "success") ||
                                  (item?.status === "off-trip" && "warning") ||
                                  "default"
                                }
                              >
                                {item?.count ? item?.count : 0}
                              </Chip>
                            </div>
                          }
                        />
                      ))}
                    </Tabs>
                  </div>
                )}
                <div className="mt-1 flex items-center justify-center gap-2 p-1">
                  <NeoTextBox
                    isClearable
                    className="w-full"
                    placeholder="Search"
                    value={filterValues?.searchText}
                    onChange={e => handleSearch(e?.target?.value)}
                    onClear={() => handleSearch("")}
                    size="sm"
                    startContent={<SearchIcon />}
                  />
                  <FilterPopover onSubmit={handleFilter} />
                </div>
              </>
            )}
            {/* <div className="mb-2 flex justify-between">
              <div className="col-span-1 px-3">
                <p className="text-lg">{liveConfig?.title}</p>
              </div>
              <div className="col-span-1 px-3">
                <NeoButtonGroup radius="sm">
                  <NeoButton
                    color={
                      selectedPage === PageType.LIVE ? "success" : "secondary"
                    }
                    size="sm"
                    radius="sm"
                    onClick={() => {
                      setViewTitle("Live");
                      setSelectedPage(PageType.LIVE);
                      setSelectedStatus(StatusType.ALL);
                      setGpsTracker(GPSTracker.STOP);
                    }}
                  >
                    Live
                  </NeoButton>
                  <NeoButton
                    color={
                      selectedPage === PageType.PLAYBACK
                        ? "success"
                        : "secondary"
                    }
                    size="sm"
                    radius="sm"
                    onClick={() => {
                      setViewTitle("Playback");
                      setSelectedPage(PageType.PLAYBACK);
                      setGpsTracker(GPSTracker.PLAYBACK);
                    }}
                  >
                    Playback
                  </NeoButton>
                </NeoButtonGroup>
              </div>
            </div> */}
          </div>
          <div
            className="flex-grow overflow-y-auto bg-[#F4F4F4]"
            style={{height: `calc(100% - ${leftContentHeight}px)`}}
          >
            {selectedPage === PageType.TRIP ? (
              <TripView
                client={filterContext.client}
                status={selectedStatus}
                onSendTripdata={data => setTripData(data)}
              />
            ) : (
              <VehicleView
                page={selectedPage}
                client={filterContext.client}
                status={selectedStatus}
              />
            )}
          </div>
        </div>
        <div className="h-full md:flex-1">
          <div
            ref={rightContent}
            className="border-b border-gray-200 bg-neo-white py-0 "
          >
            <div className="flex items-center justify-between px-5">
              <div className="w-1/4">
                {hideFeatures && (
                  <NeoTabs
                    defaultSelectedKey={selectedView}
                    items={liveConfig?.playBackType}
                    selectedKey={selectedView}
                    onSelectionChange={(key: any) => {
                      setGpsTracker(GPSTracker.STOP);
                      if (key) setSelectedView(key as PlayBackType);
                    }}
                    disabledKeys={
                      selectedPage !== PageType.LIVE || isPlayback ? ["2"] : []
                    }
                    variant="solid"
                    className="py-3"
                    size="sm"
                  >
                    {liveConfig?.playBackType?.map(item => (
                      <Tab
                        key={item?.key}
                        title={
                          <div className="flex flex-col">
                            <span>{item?.label}</span>
                          </div>
                        }
                      ></Tab>
                    ))}
                  </NeoTabs>
                )}
              </div>
              <div id="PlayBackHistory" className="w-full gap-1">
                <div className="flex justify-end">
                  <div className="flex w-full max-w-sm items-center gap-2">
                    {(isPlayback || selectedView == 2) &&
                      filterContext.client.customerType !==
                        CustomerType.SME && (
                        <NeoSelect
                          placeholder="Routes"
                          labelPlacement="outside"
                          aria-label="routes"
                          classNames={{
                            trigger: "border-none bg-gray-500/50"
                          }}
                          size="sm"
                          onChange={e => setVehicleSelctedRoute(e.target.value)}
                          defaultSelectedKeys={[vehicleSelctedRoute]}
                          selectedKeys={
                            vehicleSelctedRoute ? [vehicleSelctedRoute] : []
                          }
                        >
                          {vehicleRoutes?.trips?.map((item, index) => (
                            <SelectItem key={item.id} value={item.id}>
                              {item.name}
                            </SelectItem>
                          ))}
                        </NeoSelect>
                      )}
                    {/*isPlayback &&
                        selectedView == 1 &&
                        filterContext.client.customerType !==
                          CustomerType.SME && (
                          <>
                            {/*<NeoDatePicker
                              range={true as any}
                              showTime
                              type="icon"
                              handleDateChange={onDateChange}
                              openCalenManually={openCalenManually}
                              rangedefaultValue={selectedDateRange}
                            />
                            <NeoDateTimePicker
                              handleDateChange={onDateChange}
                            />
                          </>
                        )
                      */}
                  </div>
                  {selectedPage === PageType.LIVE && (
                    <>
                      <div className="col-span-2 flex items-center justify-end">
                        {/*selectedView == 1 && (
                          <div className="mb-2 flex">
                            <div className="mt-2 font-medium">Playback Mode</div>
                            <div>
                              <NeoSwitchInput
                                checked={isPlayback}
                                size="sm"
                                //onChange={handlePlayBackSwitch}
                                {...({
                                  onChange: (e: any) => handlePlayBackSwitch(e)
                                } as any)}
                              />
                            </div>
                          </div>
                        )}
                        {isPlayback &&
                          selectedView == 1 &&
                          filterContext.client.customerType ===
                            CustomerType.SME && (
                            <>
                              <NeoDatePicker
                                range={true as any}
                                showTime
                                type="icon"
                                handleDateChange={onDateChange}
                                openCalenManually={openCalenManually}
                                rangedefaultValue={selectedDateRange}
                              />
                            </>
                          )*/}
                        <div className="flex">
                          {liveConfig?.chips?.map((item, index) => (
                            <Tooltip
                              content={item.label}
                              key={index}
                              offset={-3}
                            >
                              {item.view == selectedView && (
                                <NeoChips
                                  key={index}
                                  className="mt-1 cursor-pointer "
                                  variant="dot"
                                  color={item.value ?? undefined}
                                  avatar={
                                    item.image ? (
                                      <Avatar name="JW" src={item.image} />
                                    ) : (
                                      ""
                                    )
                                  }
                                >
                                  {item.label}
                                </NeoChips>
                              )}
                            </Tooltip>
                          ))}
                        </div>
                        <div className="h-7 w-7">
                          {countDown < 6 && (
                            <Spinner
                              classNames={{
                                wrapper: "h-7 w-7"
                              }}
                              className="gap-0"
                              color="success"
                            >
                              <span className="absolute left-[37%] top-[13%] text-xs ">
                                {countDown}
                              </span>
                            </Spinner>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {selectedPage === PageType.TRIP && (
                <div className="flex w-3/4 items-center justify-end">
                  <div className="mr-2 flex items-center gap-1 text-[13px] font-medium">
                    <Image
                      className="h-6 w-6 items-center rounded-none"
                      alt="Boarding Point Covered"
                      src="/images/bpcoverd.svg"
                    />
                    <span>Boarding Point Covered</span>
                  </div>
                  <div className="flex items-center gap-1 text-[13px] font-medium">
                    <Image
                      className="h-6 w-6 items-center rounded-none"
                      alt="Boarding Point Uncovered"
                      src="/images/bpuncoverd.svg"
                    />
                    <span>Bording Point Uncovered</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div style={{height: `calc(100% - ${rightContentHeight}px)`}}>
            {selectedPage === PageType.LIVE && selectedView == 1 ? (
              <MapView
                page={isPlayback ? PageType.PLAYBACK : PageType.LIVE}
                dateRange={selectedDateRange}
                tabStatus={selectedStatus}
                vehicleSelctedRoute={isPlayback ? vehicleSelctedRoute : ""}
                handlePlayBackSwitch={handlePlayBackSwitch}
              />
            ) : selectedPage == PageType.TRIP && selectedView == 1 ? (
              <TripMapView page={selectedPage} tripdata={tripdata} />
            ) : (
              <TimelineView
                client={filterContext.client}
                vehicleSelctedRoute={vehicleSelctedRoute}
              />
            )}
          </div>
        </div>
      </div>
      <NeoModal
        actionType={"paymentReminder"}
        onOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        hasActions={false}
        data={remainderData}
      ></NeoModal>
    </div>
  );
};

const FilterPopover: NextPage<{onSubmit: (data: any) => void}> = ({
  onSubmit
}) => {
  const {filterValues} = useLiveContext();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const closePopOnsubmit = (data: any) => {
    onSubmit(data);
    setIsPopoverOpen(false);
  };
  const togglePopover = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };
  const validatePopover = () => {
    const filteredNames = filterValues.vehicleId as string;
    let filteredArray: any = [];
    if (Array.isArray(filterValues?.vehicleId && filterValues?.vehicleId)) {
      filteredArray = filteredNames;
    } else if (
      filterValues?.vehicleId &&
      filterValues?.vehicleId.length > 0 &&
      filteredNames !== ""
    ) {
      filteredArray = filteredNames.split(",");
    }
    if (filteredArray.length > 0) {
      return true;
    }
    return false;
  };
  return (
    //isOpen={isPopoverOpen}
    <Popover
      placement="bottom-start"
      isOpen={isPopoverOpen}
      key={"opaque"}
      showArrow
      offset={10}
      backdrop={"opaque"}
    >
      <PopoverTrigger>
        <Button
          isIconOnly
          size="sm"
          variant={validatePopover() ? "solid" : "light"}
          onClick={togglePopover}
          className="w-1 flex-none"
        >
          <Image
            className="h-6 w-6 rounded-none"
            alt="filter"
            src="/icons/filter.svg"
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <Button
          isIconOnly
          size="sm"
          variant="light"
          onClick={togglePopover}
          className="absolute right-2 top-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </Button>
        <LiveFilter onSubmit={e => closePopOnsubmit(e)} />
      </PopoverContent>
    </Popover>
  );
};
